"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGOS = void 0;
/* eslint-disable global-require */
exports.LOGOS = {
    HORIZONTAL: require('../../../images/trezor_logo_horizontal.svg'),
    VERTICAL: require('../../../images/trezor_logo_vertical.svg'),
    SYMBOL: require('../../../images/trezor_logo_symbol.svg'),
    SUITE: require('../../../images/trezor_logo_suite.svg'),
    SUITE_SQUARE: require('../../../images/trezor_logo_suite_square.svg'),
    SUITE_COMPACT: require('../../../images/trezor_logo_suite_compact.svg'),
};
